<template>
<div class="board-container">

    <v-tabs class="tab tab--block mb-50 mb-md-70 mb-lg-80">
        <v-tab class="tab__li" @click="filter.type = '세일즈웍스 코리아'">세일즈웍스 코리아</v-tab>
        <v-tab class="tab__li" @click="filter.type = '본사'">본사</v-tab>
        <v-tab class="tab__li" @click="filter.type = '지점'">지점</v-tab>
    </v-tabs>

    <div class="mb-20">
        <v-row justify="end" class="row--x-small">
            <!-- <v-col>
                <v-select v-model="filter.searchKey" :items="searchKeys" placeholder="선택" hide-details outlined></v-select>
            </v-col> -->
            <v-col cols="9" sm="10" md="auto">
                <v-text-field class="w-100 min-w-md-300px" v-model="filter.searchValue" placeholder="검색어를 입력하세요." hide-details outlined @keydown.enter="() => { search(true); }">
                </v-text-field>
            </v-col>
            <v-col cols="3" sm="2" md="auto">
                <v-btn @click="search()" class="h-100 w-100 w-md-100px color-white" color="grey-7">검색</v-btn>
            </v-col>
        </v-row>
    </div>

    <div class="board-list-faq">
        <v-expansion-panels accordion>
            <v-expansion-panel v-for="(faq, index) in faqs" :key="index">
                <v-expansion-panel-header>
                    <div class="board-list-faq__header">
                        <div class="board-list-faq__header-mark">
                            <span class="helvetica">Q</span>
                        </div>
                        <div class="board-list-faq__tit">
                            <!-- <span class="board-list-faq__category">{{ $t(`faq.type['${faq.type}']`) }}</span> -->
                            <span>{{ faq.subject }}</span>
                        </div>
                    </div>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                    <div class="board-list-faq__content">
                        <div class="board-list-faq__content-mark"><span class="helvetica">A</span></div>
                        <div class="board-list-faq__txt">
                            <span v-html="faq.content.replace(/\n/g, '<br>')" class="board-list-faq__html"></span>
                        </div>
                    </div>
                </v-expansion-panel-content>
            </v-expansion-panel>
        </v-expansion-panels>
    </div>

    <div class="mt-50 mt-lg-80">
        <v-pagination v-model="page" :length="pageCount" :total-visible="11" @input="search()" />
    </div>

</div>
</template>

<script>
import api from "@/api";
import { nextTick } from 'vue';

export default{
    props: {
        code: { type: String, default: null },
        type: { type: String },
    },
    data() {
        return {
            searchKeys: ["제목+내용", "제목", "내용"],
            filter: {
                searchKey: this.$route.query.searchKey || "",
                searchValue: this.$route.query.searchValue || "",
                type: "세일즈웍스 코리아",
            },
            faqs: [],
            pageCount: 1,

            page: +this.$route.query.page || 1,

            limit: 10
        }
    },
    mounted(){
        this.init();
    },
    computed: {
        pageCount() {
            return Math.ceil(this.totalCount / this.limit)
        },
        skip() {
            return (this.page - 1) * this.limit
        },
    },
    methods: {
        async init(){
            try{
                await this.search();
            }
            catch(error){
                console.error(error);
                alert(error.response ? error.response.data.message : error.message);
            }
        },
        async search(){
            try{
                var { summary: { totalCount} , faqs } = await api.v1.center.faqs.gets({
                    headers: { skip: this.skip, limit: this.limit }, 
                    params: this.filter
                });
                
                this.faqs = faqs;
                this.pageCount = Math.ceil(totalCount / this.limit);
            }
            catch(error){
                console.error(error);
                alert(error.response ? error.response.data.message : error.message);
            }
        }
    },
    watch: {
        "filter.type"() {
            this.page = 1
            this.init();
        }
    }
}
</script>

<style scoped>
/* Board Style - FAQ */
.board-list-faq{
    border-top:2px solid #222;
    border-bottom: 1px solid var(--border-color-light);
}
.board-list-faq .v-expansion-panel:before{
    box-shadow: none !important;
}
.board-list-faq .theme--light.v-expansion-panels .v-expansion-panel:not(:first-child):after{
    border-color:var(--border-color-light);
}
.board-list-faq .v-expansion-panel-header{
    min-height:54px;
    padding:0 24px 0 0;
}
.board-list-faq__header{
    display:flex;
    flex-wrap:wrap;
    font-size: 1.6rem;
}
.board-list-faq__header-mark{
    display: flex;
    align-items: center;
    justify-content: center;
    width: 48px;
    height: 48px;
    font-size: 1.8rem;
    font-weight: 700;
    color:var(--v-primary-base);
}
.board-list-faq__tit{
    display:flex;
    flex-wrap:wrap;
    align-items: center;
    width: calc(100% - 54px);
    font-size: 1.6rem;
    font-weight: 700;
    color:#222;
}
.board-list-faq .theme--light.v-expansion-panels .v-expansion-panel-header .v-expansion-panel-header__icon .v-icon{
    color: #686868;
}
.board-list-faq .v-expansion-panel-content__wrap{
    padding:0;
}
.board-list-faq__content{
    display: flex;
    flex-wrap: wrap;
    padding: 24px 24px 24px 54px;
    background: #f7f8f9;
    border-top: 1px solid var(--border-color-light);
}
.board-list-faq__content-mark{
    width: 54px;
    font-size: 1.4rem;
    font-weight: 700;
    text-align: center;
    color: #555;
    margin-left: -54px;
}
.board-list-faq__txt{
    width: 100%;
}
.board-list-faq__txt, .board-list-faq__txt >*{
    font-size: 1.4rem;
    color:#686868;
}
@media (min-width:576px){
}
@media (min-width:768px){
}
@media (min-width:1024px){
    .board-list-faq .v-expansion-panel-header{
        min-height:64px;
        padding:0 20px 0 0;
    }
    .board-list-faq__header-mark{
        width: 56px;
        height: 56px;
        font-size: 2.4rem;
    }
    .board-list-faq__tit{
        width: calc(100% - 64px);
        font-size: 1.8rem;
    }
    .board-list-faq__content{
        padding: 20px 40px 20px 80px;
    }
    .board-list-faq__content-mark{
        font-size: 1.6rem;
        width:64px;
        margin-left: -64px;
        /* width: 20px;
        font-size: 1.6rem;
        text-align: left;
        margin-left: 0; */
    }
    .board-list-faq__txt{
        width: calc(100% - 20px);
    }
    .board-list-faq__txt, .board-list-faq__txt >*{
        font-size: 1.6rem;
    }
}
@media (min-width:1200px){
}
</style>